import { render, staticRenderFns } from "./ScreenFactura.vue?vue&type=template&id=620f3b89&scoped=true"
import script from "./ScreenFactura.vue?vue&type=script&lang=js"
export * from "./ScreenFactura.vue?vue&type=script&lang=js"
import style0 from "./ScreenFactura.vue?vue&type=style&index=0&id=620f3b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f3b89",
  null
  
)

export default component.exports